/**
 * Summary. (Merge changes from enteredValues to original appointment)
 *
 * @access     public
 *
 * @param {Appointment}   app
 *      Appointment from state.
 * @param {Object|Array} enteredData
 *      Single row of enteredData or Array of all enteredData rows. If Array is provided, the correct row will be found over IDService
 *
 * @return {Appointment}
 *      Original appointment modified with data from enteredData object.
 */

const mergeChangesWithAppointment = (app, enteredData) => {
    if (!app) return {}; //No appointment provided, return empty object
    if (!enteredData) return app; //No modifications provided, return original appointment

    let ed = enteredData;

    if (Array.isArray(ed))
        ed = enteredData.find(c => (app.UniqueID==null && c.UniqueID==null && c.IDService === app.IDService) || (app.UniqueID!=null && app.UniqueID===c.UniqueID)); //If provided enteredData is array, we look for needed enteredData for the sam Service
    if (!ed) return app; //No modification found in array for this IDService, return original appointment.

    let appRet = Object.assign({}, app);

    let duration = ed.Duration ? ed.Duration : app.Duration;
    //Modify appointment with data from enteredData
    appRet.StartTime = ed.StartTime ? ed.StartTime : app.StartDate;
    appRet.Started = ed.Started ? 1 : 0;
    appRet.Geliefert = ed.Geliefert ? ed.Geliefert  : 0;
    appRet.ErledigteArbeiten = ed.ErledigteArbeiten || "";
    appRet.SignatureBerater = ed.SignatureBerater;
    appRet.SignatureKunde = ed.SignatureKunde;
    appRet.Duration = duration;
    appRet.AdditionalServiceNeeded = ed.AdditionalServiceNeeded ? true : false;
    appRet.pdfFieldValues = ed.pdfFieldValues;
    appRet.pdf = ed.pdf;
    appRet.EkOrt = ed.EkOrt ? ed.EkOrt : app.EkOrt;
    appRet.EkPLZ = ed.EkPLZ ? ed.EkPLZ : app.EkPLZ;
    appRet.EkStrasse = ed.EkStrasse ? ed.EkStrasse : app.EkStrasse;
    appRet.PlzOrt = appRet.EkOrt + " " + ed.EkPlz;
    appRet.GeliefertDescription = ed.GeliefertDescription;
    appRet.Persons = ed.Persons;
    appRet.Positions = ed.Positions;
    appRet.KundenBesonderheiten = ed.KundenBesonderheiten;
    appRet.Signed = ed.Signed;
    appRet.Punkt1 = ed.Punkt1;
    appRet.Punkt2 = ed.Punkt2;
    appRet.Punkt3 = ed.Punkt3;

    return appRet;
};

export default mergeChangesWithAppointment;
